//
//
//
//
//
//
//
//
//

import Header from '~/components/partials/header'
import HeaderMobile from '~/components/partials/header_mobile'
import FooterMobile from '~/components/partials/footer_mobile'
import Footer from '~/components/partials/footer'
// import Copyright from '~/components/partials/copyright'
export default {
  components: {
    HeaderMobile,
    Header,
    FooterMobile,
    Footer
    // Copyright
  },
  data () {
    return {
      openSidebar: false
    }
  },
  methods: {
    sidebarToggle (type) {
      this.openSidebar = type
    }
  }
}
